compiler('[preview-label-button]', (element) => {
  const previewPath = element.getAttribute('data-preview-path');
  const form = element.closest("form")

  function handleClick(evt) {
    evt.preventDefault()

    const params = new URLSearchParams(new FormData(form));
    params.delete("_method")
    params.delete("authenticity_token")

    Array.from(params.keys()).forEach((key) => {
      console.log(key)
      if(key.includes("api_user") || key.includes("api_secret")) {
        params.delete(key)
        console.log("delete", key)
      }
    })

    console.log(Array.from(params.entries()))

    const url = new URL(previewPath, window.location.href);
    url.search = params.toString();

    window.open(url.toString(), '_blank', 'noopener noreferrer');
  }

  element.addEventListener("click", handleClick)
})
